import React from 'react';
import { Route } from 'react-router-dom';

import AlarmeAdmin from '../../composant/AlarmeAdmin/AlarmeAdmin';
import Tasks from '../../composant/Tasks/Tasks';
import Capteur from '../../composant/Capteur/Capteur';
import ExportImpressionEcran from '../../composant/ExportImpressionEcran/ExportImpressionEcran';
import FiltreParProjet from '../../composant/FiltreParProjet/FiltreParProjet';
import Graphe from '../../composant/Graphe/Graphe';
import InterfaceClient from '../../composant/InterfaceClient/InterfaceClient';
import Maintenance from '../../composant/Maintenance/Maintenance';
import Projet from '../../composant/Projet/Projet';
import Rapport from '../../composant/Rapport/Rapport';
import Utilisateur from '../../composant/Utilisateur/Utilisateur';
import AideAdmin from '../AideAdmin/AideAdmin';
import Formation from '../Formation/Formation';

import { useSelector } from 'react-redux';
import * as url from '../../ressources/glossaires/glossaire_liens_pages';
import * as privilege from '../../ressources/glossaires/glossaire_privileges';

import Vue from '../../composant/Vue/Vue';
import AccesRestreins from '../../hoc/AccesRestreins/AccesRestreins';
import Info from '../EnTete/Info/Info';

import OngletsClient from '../../composant/InterfaceClient/Tabs/OngletsClient';
import Profil from '../../composant/Profil/Profil';
import GestionDonnees from '../../composant/GestionDonnees/GestionDonneesDemo';
import SensorDataTab from '../../composant/GestionDonnees/tabs/SensorDataTab';
import styles from './ConteneurCentral.module.scss';

import PlanningVue from 'composant/Vue/PlanningVue/PlanningVueElectrovanne';
import LabelEventGraphGeoDemo from '../../composant/Graphe/AffichageGraphe/LabelEventGraph/demo/LabelEventGraphGeoDemo';

const ConteneurCentral = ({ montrerMenu }) => {
  const projectIdUrl = useSelector(
    (state) => state.interfaceClient.project_id_url
  );

  const containerStyles = [
    styles.ConteneurCentral,
    styles.SansEnTete,
    montrerMenu ? styles.AvecMenu : styles.SansMenu,
  ].join(' ');

  return (
    <div className={containerStyles}>
      <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
        <Route path={url.projet} exact component={Projet} />
        <Route path={url.filtre} exact component={FiltreParProjet} />
        <Route path={url.capteur} exact component={Capteur} />
        <Route path={url.graphe} exact component={Graphe} />
        <Route path={url.vue} exact component={Vue} />
        <Route path={url.alarme} exact component={AlarmeAdmin} />
        <Route path={url.rapport} exact component={Rapport} />
        <Route path={url.utilisateur} exact component={Utilisateur} />
        <Route path={url.tasks} exact component={Tasks} />
        <Route path={url.gestionDonnees} exact component={GestionDonnees} />
        <Route path={url.gddm} exact component={SensorDataTab} />
        <Route path={url.maintenance} exact component={Maintenance} />
        <Route path={url.AideAdmin} exact component={AideAdmin} />
        <Route path={'/planning/:viewId'} exact component={PlanningVue} />
        <Route
          path={'/export_impression_ecran-visualisation-2269/:viewId'}
          exact
          component={PlanningVue}
        />
      </AccesRestreins>
      <Route
        path={url.accueil}
        exact
        render={(props) => (
          <OngletsClient {...props} montrerMenu={montrerMenu} />
        )}
      />
      <Route
        path={url.demo_label_event_graph_geo}
        exact
        component={LabelEventGraphGeoDemo}
      />
      <Route path={url.profil} exact component={Profil} />
      <Route path={url.Formation} exact component={Formation} />
      <Route path={url.Info} exact component={Info} />

      <Route
        path={url.regex_projet_client}
        component={() => (
          <InterfaceClient
            project_id={projectIdUrl}
            montrerMenu={montrerMenu}
          />
        )}
      />
    </div>
  );
};

export default ConteneurCentral;
